//@ts-ignore
import jwt_decode from "jwt-decode";

export const getUserInfo = (): any => {
    const token = localStorage.getItem("idToken");
    return token && jwt_decode(token);
};
